import request from '@/utils/request'

let PointChannelApi = {
    /*商品列表*/
    channelList(data) {
        return request._post('/shop/plus.points.channel/index', data);
    },
    /*添加渠道*/
    addChannel(data) {
        return request._post('/shop/plus.points.channel/add', data);
    },
    /*获取渠道*/
    getChannel(data) {
        return request._get('/shop/plus.points.channel/add', data);
    },
    /*获取积分渠道*/
    getPointChannel(data) {
        return request._get('/shop/plus.points.channel/edit', data);
    },
    /*编辑积分渠道*/
    editPointChannel(data) {
        return request._post('/shop/plus.points.channel/edit', data);
    },
    /*删除渠道*/
    deleteChannel(data) {
        return request._post('/shop/plus.points.channel/delete', data);
    },

}
export default PointChannelApi;



// WEBPACK FOOTER //
// ./src/api/pointchannel.js